module.exports = __webpack_public_path__ + "static/media/phone2.8148ea4d.png";